import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

import { BillingPaymentaccountFeatureModule } from '@amfam/billing/paymentaccount/feature';
import { BillingSchedulepaymentFeatureModule } from '@amfam/billing/schedulepayment/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PolicyPipesModule } from '@amfam/policy/pipes';
import { ProfileFeatureModule } from '@amfam/profile/feature';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { AutopayCardComponent } from './components/autopay-card/autopay-card.component';
import { BillAccountAddConfirmationComponent } from './components/bill-account-add-confirmation/bill-account-add-confirmation.component';
import { BillAccountAddComponent } from './components/bill-account-add/bill-account-add.component';
import { BillAccountGetStartedComponent } from './components/bill-account-get-started/bill-account-get-started.component';
import { BillAccountManageComponent } from './components/bill-account-manage/bill-account-manage.component';
import { BillAccountRegisterComponent } from './components/bill-account-register/bill-account-register.component';
import { BillingDashboardWrapperComponent } from './components/billing-dashboard-wrapper/billing-dashboard-wrapper.component';
import { BillingPaymentConfirmationComponent } from './components/billing-payment-confirmation/billing-payment-confirmation.component';
import { ManageAutopayComponent } from './components/manage-autopay/manage-autopay.component';
import { PaymentTermsComponent } from './components/payment-terms';
import { PrintConfirmationWrapperComponent } from './components/print-confirmation-wrapper/print-confirmation-wrapper.component';

@NgModule({
  imports: [
    BrandDirectivesModule,
    CommonModule,
    UiKitModule,
    SharedServicesModule,
    RouterModule,
    PipesModule,
    PolicyPipesModule,
    FormsModule,
    ReactiveFormsModule,
    NgxDatatableModule,
    DsRouterLinkModule,
    ImpersonationModule,
    BillingSchedulepaymentFeatureModule,
    BillingPaymentaccountFeatureModule,
    PolicyPipesModule,
    BrandDirectivesModule,
    BillingSharedUiModule,
    ProfileFeatureModule
  ],
  declarations: [
    BillAccountAddConfirmationComponent,
    BillAccountManageComponent,
    BillingPaymentConfirmationComponent,
    PrintConfirmationWrapperComponent,
    BillAccountAddComponent,
    BillAccountGetStartedComponent,
    BillAccountRegisterComponent,
    AutopayCardComponent,
    PaymentTermsComponent,
    BillingDashboardWrapperComponent,
    ManageAutopayComponent
  ],
  exports: [
    BillAccountAddConfirmationComponent,
    BillAccountManageComponent,
    BillingPaymentConfirmationComponent,
    PrintConfirmationWrapperComponent,
    BillAccountAddComponent,
    BillAccountGetStartedComponent,
    BillAccountRegisterComponent,
    AutopayCardComponent,
    BillingDashboardWrapperComponent,
    ManageAutopayComponent
  ],
  providers: [DatatableComponent]
})
export class BillingSharedFeatureModule {}
